import { makeStyles } from '@material-ui/core/styles';

export const useProductCollapseDesktopStyles = makeStyles((theme) => ({
  accordion: {
    border: `1px solid #BCBCBC`,
    '&.MuiAccordion-rounded': {
      borderRadius: (props) => (props.somethingBelow ? '8px 8px 0px 0px' : 8),
    },
    '&.MuiAccordion-rounded:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
    '&.MuiAccordion-root:before': {
      height: '0px',
    },
    '&.MuiAccordion-root.Mui-expanded': {
      margin: 0,
    },
  },
  accordionDivider: {
    borderBottom: (props) => (props.expanded ? `1px solid #BCBCBC` : ''),
    '&.MuiAccordionSummary-root.Mui-expanded': {
      height: 58,
    },
    '&.MuiAccordionSummary-root': {
      height: 58,
    },
    paddingRight: 32,
  },
  details: {
    '&.MuiAccordionDetails-root': {
      padding: '24px 32px',
    },
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const useProductCollapseHeaderStyles = makeStyles((theme) => ({
  image: {
    width: 38,
    marginRight: 20,
  },
  textName: {
    color: (props) =>
      props.expanded || props.mouseOver
        ? theme.palette.primary.main
        : '#1a1a1a',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 'bolder',
    width: '200px',
  },
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    '& :not(:last-child)': {
      marginRight: 10,
    },
  },
}));

export const useProductDetailDesktopStyles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '0.4fr 1fr 1fr',
    columnGap: 50,
  },
  divider: {
    margin: '0 -32px',
  },
  underProduct: {
    marginTop: 20,
  },
  button: {
    marginTop: 20,
  },
  loading: {
    margin: '0 auto',
  },
  loadingImage: {
    height: 80,
    width: 80,
  },
}));

export const useProductDescriptionStyles = makeStyles(() => ({
  text: {
    marginBottom: 4,
    fontSize: 16,
  },
}));
